// Host for the player embeds this generator hands a client.
//
// Baked at build time by webpack DefinePlugin (see webpack.config.js and
// netlify.toml): production builds emit `player.invintus.com`, while
// stage and preview emit the beta channel, because an embed generated
// there exists to exercise the unreleased player. A production host
// would render without the Shadow-DOM boundary or the theme tokens and
// give no sign of it -- an unread theme just falls back to defaults.
//
// The `||` fallback covers jest, which has no DefinePlugin. Production
// is the safe default: an unset var can never leak beta into an embed a
// client pastes onto their own site.
//
// `eventlisting.invintus.com` has no beta channel and stays fixed.
const PLAYER_HOST = process.env.PLAYER_EMBED_HOST || 'player.invintus.com';

export default {
    getHost: function () {

        const { renderMode, domain } = this.props;

        let url = '';

        switch (renderMode) {
            case 'iframe':
                switch (domain) {
                    case 'listing':
                        url = 'eventlisting.invintus.com/index.html';
                        break;

                    case 'player':
                        url = PLAYER_HOST + '/';
                        break;

                    case 'persistent':
                        url = PLAYER_HOST + '/index.html';
                        break;
                }
                break;

            case 'script' :
                switch (domain) {
                    case 'listing':
                        url = 'eventlisting.invintus.com/app.js';
                        break;

                    case 'player':
                        url = PLAYER_HOST + '/app.js';
                        break;

                    case 'persistent':
                        url = PLAYER_HOST + '/app.js';
                        break;
                }
                break;

            case 'hosted':
                url = PLAYER_HOST + '/';
                break;
        }

        return 'https://' + url;
    }
};
